/*********************************************************************
 * © Copyright IBM Corp. 2022
 * Copyright © 2022 Randori https://randori.com - All Rights Reserved.
 *********************************************************************/
import { Server } from 'miragejs'

import { GET_COUNTS_URL } from '../constants'
import getCounts from '../fixtures/get-counts.json'

export const getCountsRoutes = (server: Server): void => {
  server.get(GET_COUNTS_URL, () => {
    return getCounts
  })
}
